/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

export const PRODUCT_NAME = import.meta.env.VITE_PRODUCT_NAME || "Klava Call";
